import { FC, useRef } from 'react'

import { CircularProgress, Icon, IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'

import { s } from './styles'

type Props = {
  value: string
  onChange: (value: string) => void
  clearSearch: () => void
  isLoading: boolean
}

export const SearchInput: FC<Props> = ({ value, onChange, clearSearch, isLoading }) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const clear = () => {
    clearSearch()
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <s.InputWrapper>
      <Icon name={IconName.SEARCH} />
      <input value={value} onChange={(e) => onChange(e.target.value)} autoFocus ref={inputRef} role="textbox" />
      {isLoading && <CircularProgress size={16} />}
      {value && <IconButton icon={IconName.DELETE_GRAY_CROSS} onClick={clear} data-testid="clear-search-button" />}
    </s.InputWrapper>
  )
}
